import { useCallback } from 'react'

import { useUnit } from 'effector-react'

import { DIALOG_TYPE } from '@/dialogs/constants'
import { $activeChatDetails } from '@/models/chattingUI/chats/chats.ts'
import { openDialog } from '@/models/dialogs'
import { useToggleMuteChat } from '@/modules/chatting/hooks/use-toggle-mute-chat.ts'
import MutedIcon from '@/modules/chatting/icons/muted.svg'
import NotificationIcon from '@/modules/chatting/icons/notification.svg'

import { IconButton } from '../components/icon-button'

export const ChatMuteIndicator = () => {
  const activeChat = useUnit($activeChatDetails)
  const { isMutedNotifications } = activeChat ?? {}
  const { muteChat, isUnmuteChatLoading, unmuteChat } = useToggleMuteChat()

  const handleMuteToggleClick = useCallback(() => {
    if (isMutedNotifications) {
      unmuteChat()
    } else {
      openDialog({
        type: DIALOG_TYPE.MUTE_CHAT,
        onMute: muteChat,
      })
    }
  }, [isMutedNotifications, muteChat, unmuteChat])

  return (
    <IconButton
      tooltip={isMutedNotifications ? 'Unmute' : 'Mute'}
      onClick={handleMuteToggleClick}
      icon={isMutedNotifications ? MutedIcon : NotificationIcon}
      disabled={isUnmuteChatLoading && isMutedNotifications}
      iconClassName="h-3 w-3 sm:h-5 sm:w-5"
    />
  )
}
